import { render, staticRenderFns } from "./FormCroPromotionSameBranch.vue?vue&type=template&id=8dccba0a&scoped=true&lang=html&"
import script from "./FormCroPromotionSameBranch.vue?vue&type=script&lang=js&"
export * from "./FormCroPromotionSameBranch.vue?vue&type=script&lang=js&"
import style0 from "./FormCroPromotionSameBranch.vue?vue&type=style&index=0&id=8dccba0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dccba0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCardActions,VCheckbox,VCol,VContainer,VForm,VRow,VSpacer})
